import React from 'react';
import cn from 'classnames';
import Image from 'next/image';

import styles from './LikeCounter.module.scss';
import Props from './LikeCounter.props';

const LikeCounter = ({ likecount, className }: Props) => {
  let resultString = likecount.toString();

  if (likecount > 999) {
    resultString = (likecount / 1000).toFixed(1) + 'k';
  }

  if (likecount > 999999) {
    resultString = (likecount / 1000000).toFixed(1) + 'm';
  }

  return (
    <div className={cn(styles.LikeCounter, className)}>
      <Image
        src={require('@assets/images/heart@3x.png')}
        alt=""
        quality={60}
        layout="fill"
        className={styles.BackgroundImage}
      />
      <p className={styles.Count}>{resultString}</p>
    </div>
  );
};

export default LikeCounter;
